import script from "./BillingAddress.vue?vue&type=script&lang=ts&setup=true"
export * from "./BillingAddress.vue?vue&type=script&lang=ts&setup=true"

import "./BillingAddress.vue?vue&type=style&index=0&id=c312cb50&lang=less"
import "./BillingAddress.vue?vue&type=style&index=1&id=c312cb50&lang=less&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c312cb50"]])

export default __exports__